import styled from "styled-components";
import { textStylePlaceholder } from "..";
import { colors } from "common/const/colors";

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;

export const TooltipText = styled.span`
  ${textStylePlaceholder}
  position: absolute;
  bottom: calc(100% + 0.5rem);
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--DarkNavy);
  color: var(--White);
  padding: 0.75rem;
  border-radius: 0.5rem;
  white-space: nowrap;

  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  z-index: 10;

  /* 말풍선 삼각형 */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0.4rem 0.5rem;
    border-style: solid;
    border-color: var(--DarkNavy) transparent transparent transparent;
  }
`;

export const Tooltip = ({ style, text, children }) => {
  return (
    <TooltipWrapper style={style}>
      <TooltipText>{text}</TooltipText>
      {children}
    </TooltipWrapper>
  );
};

const NivoTooltipText = styled(TooltipText)`
  opacity: 1;
  visibility: visible;
  position: relative;
  bottom: 1rem;
  left: auto;
  transform: none;
`;

export const CustomChartTooltip = ({ ...props }) => {
  const { datum, point } = props;
  let displayValue = null;

  if (props.data) {
    // ResponsiveBar
    displayValue = props.data.value;
  } else if (datum) {
    // ResponsivePie
    displayValue = datum.value;
  } else if (point) {
    // ResponsiveLine
    displayValue = point.data.yFormatted;
  } else {
    return null;
  }
  return <NivoTooltipText>{displayValue}</NivoTooltipText>;
};
